import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "./apiClient";

let listenersReady = false;
let registering = false;
let localNotificationId = Date.now() % 100000;

const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const setupAdminPushNotifications = async () => {
  if (!isNativeApp() || registering) return false;
  registering = true;

  try {
    if (!listenersReady) {
      PushNotifications.addListener("registration", async (token) => {
        if (!token?.value) return;
        try {
          await api.post("/push-tokens", {
            token: token.value,
            platform: Capacitor.getPlatform(),
            app: "kelifa-admin",
          });
          localStorage.setItem("kelifa_push_token_registered", token.value);
        } catch (error) {
          console.warn("No se pudo registrar token push", error);
        }
      });

      PushNotifications.addListener("registrationError", (error) => {
        console.warn("Error registrando push notifications", error);
      });

      PushNotifications.addListener("pushNotificationActionPerformed", () => {
        window.location.href = "/admin/pedidos";
      });

      PushNotifications.addListener("pushNotificationReceived", async (notification) => {
        await showForegroundSystemNotification(notification);
      });

      LocalNotifications.addListener("localNotificationActionPerformed", () => {
        window.location.href = "/admin/pedidos";
      });

      listenersReady = true;
    }

    let permission = await PushNotifications.checkPermissions();
    if (permission.receive === "prompt") {
      permission = await PushNotifications.requestPermissions();
    }

    if (permission.receive !== "granted") {
      return false;
    }

    if (Capacitor.getPlatform() === "android") {
      await PushNotifications.createChannel({
        id: "kelifa_orders",
        name: "Pedidos Kelifa",
        description: "Avisos de pedidos nuevos y cambios importantes",
        importance: 5,
        visibility: 1,
        sound: "default",
        lightColor: "#761B38",
      }).catch(() => {});
      await LocalNotifications.createChannel({
        id: "kelifa_orders",
        name: "Pedidos Kelifa",
        description: "Avisos de pedidos nuevos y cambios importantes",
        importance: 5,
        visibility: 1,
        sound: "default",
        lightColor: "#761B38",
      }).catch(() => {});
    }

    await PushNotifications.register();
    await registerHuaweiPushTokenIfAvailable();
    return true;
  } catch (error) {
    console.warn("Push notifications no disponibles", error);
    await registerHuaweiPushTokenIfAvailable();
    return false;
  } finally {
    registering = false;
  }
};

const registerHuaweiPushTokenIfAvailable = async () => {
  try {
    if (!isNativeApp() || Capacitor.getPlatform() !== "android") return false;

    const huaweiPush = window.Capacitor?.Plugins?.HuaweiPush;
    if (!huaweiPush?.isAvailable || !huaweiPush?.getToken) return false;

    const availability = await huaweiPush.isAvailable();
    if (!availability?.available) return false;

    const result = await huaweiPush.getToken();
    if (!result?.token) return false;

    await api.post("/push-tokens", {
      token: result.token,
      platform: "huawei",
      app: "kelifa-admin",
    });
    localStorage.setItem("kelifa_huawei_push_token_registered", result.token);
    return true;
  } catch (error) {
    console.warn("Huawei Push no disponible o no configurado", error);
    return false;
  }
};

const showForegroundSystemNotification = async (notification) => {
  if (!isNativeApp()) return;

  try {
    const permission = await LocalNotifications.checkPermissions();
    if (permission.display !== "granted") {
      const requested = await LocalNotifications.requestPermissions();
      if (requested.display !== "granted") return;
    }

    const title = notification?.title || notification?.data?.title || "Kelifa";
    const body = notification?.body || notification?.data?.body || "Tienes una nueva notificación.";

    localNotificationId = (localNotificationId + 1) % 2147483647;
    await LocalNotifications.schedule({
      notifications: [
        {
          id: localNotificationId,
          title,
          body,
          channelId: "kelifa_orders",
          schedule: { at: new Date(Date.now() + 250) },
          extra: notification?.data || {},
        },
      ],
    });
  } catch (error) {
    console.warn("No se pudo mostrar notificación local en primer plano", error);
  }
};
